import React, { useEffect } from 'react';
// import { _config_change_app_env_backend_sim, _config_change_company_env_mes, _config_change_company_env_mes_test_is_enabled } from '../utils/config';
import AppYourmap from './AppYourmap';
import TestTemp1 from './TestTemp1';


const App = (props) => {

  /*
  return (
    <>
      <TestTemp1 />
      <AppYourmap />
    </>
  );
  */

  
  return (
    <>
      <AppYourmap />
    </>
  );
  





  /*
  return (
    <>
      <ZZTempSurvey />
      <ToastBig />
    </>
  );
  */
};

export default App;